import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import { WORK_PAGE_TYPE } from '../../../../constants';
import { FooterLocaleVisibilityContext } from '../../../../context/FooterLocaleVisibilityContext';
import { useCountryCode } from '../../../../hooks/useCountryCode';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import { TrackFeesDrawerUpdateClicked } from '../../../../utils/analytics';
import { renderArtistsNamesFromPageContent } from '../../../../utils/artists';

interface WorkPreviewProps<T extends ProductPurchaseDetails> {
  artists: ArtistPageContent[] | undefined;
  product: ProductType;
  purchasing: ProductPurchasingController<T>;
}

const CountryPicker: React.FC<WorkPreviewProps<ProductPurchaseDetails>> = (
  props,
) => {
  const { artists, product, purchasing } = props;
  const [countryCode] = useCountryCode();
  const { pricesAndAvailability } = product;
  const { t } = useTranslation('countries');
  const { t: tProduct } = useTranslation('product');
  const { show } = useContext(FooterLocaleVisibilityContext);

  return (
    <div className="flex items-center justify-center rounded-sm border border-divider/20 p-4">
      <div className="flex flex-1 flex-col overflow-hidden">
        <p className="truncate font-bold">
          {tProduct('drawers.fees.shipping.title')}
        </p>
        <p className="truncate">{t(countryCode) ?? 'Unknown'}</p>
      </div>
      <div className="shrink-0">
        <Button
          fullWidth
          label={tProduct('drawers.fees.shipping.updateButton')}
          onClick={() => {
            TrackFeesDrawerUpdateClicked({
              page: WORK_PAGE_TYPE,
              productTitle: product.title,
              productPricesAndCurrencies:
                pricesAndAvailability.pricesAndCurrencies,
              productCurrencyCode: purchasing.product?.currency,
              productMedium: product.medium,
              productPrice: purchasing.product?.price,
              artistName: renderArtistsNamesFromPageContent(artists),
            });

            show(`${WORK_PAGE_TYPE} page`);
          }}
          size="md"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default CountryPicker;
